var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"network",attrs:{"id":"mynetwork"}},[_vm._v("N/A")]),_c('b-button',{on:{"click":_vm.clusterByGroup}},[_vm._v("Cluster By group")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }